module.exports = __webpack_public_path__ + "static/media/close-menu.5f27becd.svg";